import { render, staticRenderFns } from "./ProgBar.vue?vue&type=template&id=470ca0d7&"
import script from "./ProgBar.vue?vue&type=script&lang=js&"
export * from "./ProgBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports